module.exports = __webpack_public_path__ + "static/media/2.0aef47e6.png";